/* tslint:disable */
/* eslint-disable */
/**
 * Syte Products API
 * API services for CRA, Files, and Collaborators
 *
 * The version of the OpenAPI document: v0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GroupFilterDtoFromJSON, GroupFilterDtoToJSON, } from './GroupFilterDto';
/**
 * @export
 */
export const SafeguardGroupFilterResponseGroupTypeEnum = {
    TopLevelControl: 'TOP_LEVEL_CONTROL',
    Product: 'PRODUCT',
    NistCsfFunction: 'NIST_CSF_FUNCTION',
    CisImplementationGroup: 'CIS_IMPLEMENTATION_GROUP',
    InsurabilityRating: 'INSURABILITY_RATING',
    InsuranceCategory: 'INSURANCE_CATEGORY',
    A8Outcomes: 'A8_OUTCOMES',
    A8MaturityLevel: 'A8_MATURITY_LEVEL',
    QuickStart: 'QUICK_START'
};
/**
 * Check if a given object implements the SafeguardGroupFilterResponse interface.
 */
export function instanceOfSafeguardGroupFilterResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function SafeguardGroupFilterResponseFromJSON(json) {
    return SafeguardGroupFilterResponseFromJSONTyped(json, false);
}
export function SafeguardGroupFilterResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ordinal': !exists(json, 'ordinal') ? undefined : json['ordinal'],
        'groupType': !exists(json, 'groupType') ? undefined : json['groupType'],
        'groupFilterName': !exists(json, 'groupFilterName') ? undefined : json['groupFilterName'],
        'safeguardGroups': !exists(json, 'safeguardGroups') ? undefined : (json['safeguardGroups'].map(GroupFilterDtoFromJSON)),
    };
}
export function SafeguardGroupFilterResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ordinal': value.ordinal,
        'groupType': value.groupType,
        'groupFilterName': value.groupFilterName,
        'safeguardGroups': value.safeguardGroups === undefined ? undefined : (value.safeguardGroups.map(GroupFilterDtoToJSON)),
    };
}
